import ReactMarkdown from 'react-markdown';
import { remarkPlugins, rehypePlugins } from '../../utils/markdown-config';
import styles from './AsyncTaskMarkdown.module.css';

interface AsyncTaskMarkdownProps {
  readonly content: string;
  readonly tone?: 'default' | 'error';
}

/**
 * Renders async-task result bodies (delivery + per-unit) as markdown so
 * tables/headers/lists read as UI instead of raw pipe/hash syntax.
 */
export function AsyncTaskMarkdown({
  content,
  tone = 'default',
}: AsyncTaskMarkdownProps) {
  return (
    <div
      className={`${styles.markdown} ${tone === 'error' ? styles.error : ''}`}
    >
      <ReactMarkdown
        remarkPlugins={remarkPlugins}
        rehypePlugins={rehypePlugins}
      >
        {content}
      </ReactMarkdown>
    </div>
  );
}
